import { StateController, platform, serverData } from "@aceroll/core";
import { featureRound } from "../services";

class FeatureRoundCompletedController extends StateController {
    constructor() {
        super("feature.round.completed");
    }

    async onStart() {
        const response = serverData.currentResponse;
        // const hasMaxWin = serverData.nextResponses.length === 2 && (serverData.nextResponses[0].etn === 'max_win_reached');
        // if (hasMaxWin) {
        //     platform.setMaxWin();
        // }
        // console.log('TODO: set featrue reound completed amount', response);
        platform.setFeatureRoundCompleted(featureRound.getTotalWin());
        featureRound.stop();

        // Debug
        // platform.onceClickScreen().then(() => {
        //     this.stop();
        // });

        this.stop();
    }

    onStop() {

    }
}

export default FeatureRoundCompletedController;